import { Link } from 'react-router-dom'
import { Compass } from 'lucide-react'
import { useMinCopy } from '@/i18n/useUiLocale'

export function ExploreCatalogLink() {
  const { nav, dashboard } = useMinCopy()

  return (
    <Link
      to="/catalog"
      className="inline-flex items-center gap-2 rounded-lg border border-border/60 bg-card px-4 py-3 text-sm text-muted-foreground transition-colors hover:border-primary/30 hover:text-foreground"
      data-testid="explore-catalog-link"
    >
      <Compass className="h-4 w-4 text-primary" aria-hidden />
      <span>
        <span className="font-medium text-foreground">{nav.catalog}</span>
        <span className="ml-2 hidden sm:inline">{dashboard.catalogExploreHint}</span>
      </span>
    </Link>
  )
}
